import { z } from 'zod'

export const COACHING_YPO_ADMIN_IMPORT_CONTRACT_VERSION = '1.0.0' as const
export const coachingYpoAdminImportResponseSchema = z.unknown()
export type CoachingYpoAdminImportResponse = z.infer<typeof coachingYpoAdminImportResponseSchema>
